<template>
  <div style="height: 100%; overflow: auto;">
    <div class="v-data-table-off-overflow" v-if="isLoaded">
      <v-data-table
        dense
        :items="table.items"
        :headers="table.headers"
        disable-pagination
        hide-default-footer
        fixed-header
      >
      </v-data-table>

    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    ></v-progress-linear>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StatisticByQueues',
  props: {
    view: String,
    widget: Object,
  },
  data() {
    return {
      isLoaded: false,
      table: {
        items: [],
        headers: [
          {text: 'Очередь', value: 'queue'},
          {text: 'Поступившие', value: 'total_calls_count'},
          {text: 'Принятые', value: 'accepted_calls_count'},
          {text: 'Пропущенные (всего пропущенные)', value: 'missed_calls_count'},
          {text: 'Длительность (в мин., поминутная тарификация)', value: 'total_duration'},
          {text: 'Средняя длительность (всех принятых звонков)', value: 'avg_duration'},
        ],
      },
    }
  },

  computed: {
    ...mapGetters({
    }),
  },

  watch: {},

  methods: {
    ...mapActions({
      loadStatisticByQueues: 'dashboard/loadStatisticByQueues',
    }),

    async loadData() {
      this.isLoaded = false;
      this.table.items = await this.loadStatisticByQueues(this.widget.params);
      this.isLoaded = true;
    },
  },
  
  mounted() {
    this.loadData();
  },
}
</script>


<style scoped lang="scss">
.name-cell {
  display: grid;
  align-items: center;
  padding-left:0.2rem;
  padding-right:0.2rem;

  &.name {
    min-width: 120px;
    width: 100%;
  }

  .sliced-name {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>